import {
    ADV_SALES_SUCCESS,
    ADV_SALES_LOADING

} from '../actions/advSalesAction';

const initialState = {
    advSalesData: null,
    isLoading: true,
};

const advSalesReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case ADV_SALES_SUCCESS:
            return { ...state, advSalesData: action.data, isLoading: false };

        case ADV_SALES_LOADING:
            return { ...state, isLoading: action.isLoading };

        default:
            return state;
    }
};

export default advSalesReducer;
